import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import Modal from "react-modal";
import { selectUser } from "../../components/auth/auth.selector";
import CommonStructured from "../../components/common-components/CommonStructured";
import HelmetWrapper from "../../HelmetWrapper";
import { fetchMetabseLinksData } from "../../redux/website-reducers/websiteSlice";
import MetabaseLinkLists from "../../components/metabase/MetabaseLinkLists";
import MetabseLinkForm from "../../components/metabase/MetabseLinkForm";
import CmnFilters from "../../components/lead-management/common/CmnFilters";
import "../../styles/metabase/metabse-date.css";

const MetabaseLinks = () => {
  const userInfoData = useSelector(selectUser);
  const dispatch = useDispatch();
  const { metabseLinksLoading } = useSelector((state) => state.hygiene);

  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);
  const iniAllFilter = {
    isActive: "",
    selectedStartDate: "",
    selectedEndDate: "",
    searchString: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    page: isPage + 1,
    limit: pageLimit || 10,
    status: allFilters.isActive?.value || "",
    date_from: allFilters.selectedStartDate || "",
    date_to: allFilters.selectedEndDate || "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);
  const iniModvalues = {
    isModOpen: false,
    cardName: "",
    rowData: "",
  };
  const [modValues, setModValues] = useState(iniModvalues);

  const onResetFilters = () => {
    setAllFilters(iniAllFilter);
  };

  const onClickSearch = () => {
    setIsPage(0);

    if (allFilters.searchString) {
      setSearchFilterApplied(true);
      setFilters((prevs) => ({ ...prevs, search: allFilters.searchString }));
    }
  };

  const onCloseModal = () => {
    setModValues(iniModvalues);
  };

  function getMetabseLinks(filters) {
    dispatch(
      fetchMetabseLinksData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  useEffect(() => {
    getMetabseLinks(filters);
  }, [filters]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      limit: pageLimit || 10,
      status: allFilters.isActive?.value || "",
      date_from: allFilters.selectedStartDate || "",
      date_to: allFilters.selectedEndDate || "",
    }));
  }, [
    isPage,
    pageLimit,
    allFilters.isActive,
    allFilters.selectedStartDate,
    allFilters.selectedEndDate,
  ]);

  useEffect(() => {
    if (allFilters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setFilters((prevs) => ({ ...prevs, search: "" }));
      setIsPage(0);
    }
  }, [allFilters.searchString]);

  return (
    <HelmetWrapper title="WTF: Metabase Links">
      <Container className="bg-cloud-k px-50px gobal-container" fluid>
        <Modal
          isOpen={modValues.isModOpen}
          onRequestClose={onCloseModal}
          contentLabel="Modal"
          ariaHideApp={false}>
          {modValues.cardName === "add" || modValues.cardName === "edit" ? (
            <MetabseLinkForm
              userInfoData={userInfoData}
              rowData={modValues.rowData}
              isEdit={modValues.cardName === "edit"}
              closeModal={onCloseModal}
              callFunction={() => getMetabseLinks(filters)}
            />
          ) : null}
        </Modal>

        <Row>
          <Col>
            <CommonStructured
              pageHeading={"Metabase Links"}
              createBtnTxt={"+ Add New Metabase Link"}
              onClickCreateBtn={() =>
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  cardName: "add",
                }))
              }
              isReload={() => getMetabseLinks(filters)}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <CmnFilters
              from={"metabase-links"}
              userInfoData={userInfoData}
              onClickReset={onResetFilters}
              filters={allFilters}
              setFilters={setAllFilters}
              onClickSearch={onClickSearch}
              searchFilterApplied={searchFilterApplied}
              isLoading={metabseLinksLoading}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <MetabaseLinkLists
              userInfoData={userInfoData}
              isPage={isPage}
              setIsPage={setIsPage}
              pageLimit={pageLimit}
              setPageLimit={setPageLimit}
              setModValues={setModValues}
              callFunction={() => getMetabseLinks(filters)}
            />
          </Col>
        </Row>
      </Container>
    </HelmetWrapper>
  );
};

export default MetabaseLinks;
